import React from "react";
import { Card } from "antd";
import piggy from "../../assets/icons/piggy.svg";
import Arrow from "../../assets/icons/UpArrow.svg";
import downArrow from "../../assets/icons/DownArrow.svg";
import appointmentIcon from "../../assets/icons/appointment icon.svg";
import Button from "./button";
const HomeOrderCard = ({ appointment, data, filter, percentage }) => {
  return (
    <Card className="h-18 shadow-md">
      {appointment ? (
        <div className="m-2  mt-1">
          <div className="flex">
            <img className="mr-1" src={appointmentIcon} alt="Background" />
            <p className="text-base font-medium text-primaryPurple">
              Appointments
            </p>
          </div>
          {data ? (
            <div>
              <div className="flex items-center">
                <p className="my-0 text-black text-4xl font-normal">
                  {parseFloat(data?.totalAppointments ?? 0).toLocaleString()}
                </p>
                {/* <Button
                  title="2 New"
                  className="m-1 bg-red w-5.14 !h-3 !rounded-sm flex items-center"
                /> */}
              </div>
              <div className="flex">
                <img
                  className="mr-1"
                  src={percentage?.appointmentIsPositive ? Arrow : downArrow}
                  alt="Background"
                />
                <p
                  className={`${
                    percentage?.appointmentIsPositive
                      ? "text-green truncate"
                      : "text-red"
                  } text-lg`}
                >
                  {Math.abs(percentage?.appointmentPercentage?.toFixed(0)) ?? 0}
                  %{" "}
                  <span className="text-grey font-medium	 text-sm">
                    vs previous {filter === "weekly" ? "week" : "month"}
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <p className="opacity-60 text-lg mt-2 flex justify-center">
              No Appointments...
            </p>
          )}
        </div>
      ) : (
        <div className="m-2 mt-1">
          <div className="flex">
            <img className="mr-1" src={piggy} alt="Background" />
            <p className="text-base font-medium text-primaryOrange">
              Total Orders
            </p>
          </div>
          {data ? (
            <div>
              <div>
                <p className="text-text-black text-4xl font-normal my-0">
                  {parseFloat(data?.totalSales).toLocaleString()}
                </p>
              </div>
              <div className="flex">
                <img
                  className="mr-1"
                  src={percentage?.orderIsPositive ? Arrow : downArrow}
                  alt="Background"
                />
                <p
                  className={`${
                    percentage?.orderIsPositive ? "text-green" : "text-red"
                  } text-lg`}
                >
                  {Math.abs(percentage?.orderPercentage?.toFixed(0)) ?? 0}%{" "}
                  <span className="text-grey font-medium	truncate text-sm">
                    vs previous {filter === "weekly" ? " week" : " month"}
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <p className="opacity-60 text-lg mt-2 flex justify-center">
              No Orders...
            </p>
          )}
        </div>
      )}
    </Card>
  );
};
export default HomeOrderCard;
